import { useEffect } from 'react';

const SITE_NAME = 'AliteroEU';
const BASE_URL = 'https://www.alitero.eu';

/**
 * Setzt document.title, Meta-Description und den Canonical-Link pro Seite.
 * Kein react-helmet nötig — bei einer Handvoll Routen reicht ein Hook.
 * `path` ist die Route ohne führenden Slash (z.B. 'services'), leer für die Startseite.
 */
export function usePageMeta({ title, description, path = '' }) {
  useEffect(() => {
    if (title) {
      document.title = title.includes(SITE_NAME) ? title : `${title} | ${SITE_NAME}`;
    }

    if (description) {
      let meta = document.querySelector('meta[name="description"]');
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('name', 'description');
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', description);
    }

    const canonicalUrl = `${BASE_URL}/${path}`.replace(/\/$/, '') || BASE_URL;
    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      document.head.appendChild(link);
    }
    link.setAttribute('href', canonicalUrl);
  }, [title, description, path]);
}
